"use client";

import FormFields from "../Fields";
import Buttons from "@/components/core/Buttons";
import { UseFormReturn } from "react-hook-form";
import {
  ToolSchema,
  UpdateAiConfigurationData,
} from "@/components/shared/Forms/UpdateAiConfigurationForm/schema";
import { ITool } from "@/actions/ai-configuration/tool/types";

interface IUpdateToolFormProps {
  form: UseFormReturn<UpdateAiConfigurationData>;
  index: number;
  onSave: (tool: ITool, index: number) => void;
  onClose: () => void;
}

const UpdateToolForm = ({
  form,
  index,
  onSave,
  onClose,
}: IUpdateToolFormProps) => {
  const onSubmit = () => {
    const tool = form.getValues(`tools.${index}`);

    const parsed = ToolSchema.safeParse(tool);

    form.clearErrors();

    if (!parsed.success) {
      parsed.error.errors.forEach((err) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        form.setError(`tools.${index}.${err.path[0]}` as any, {
          message: err.message,
        });
      });
      return;
    }

    onSave(parsed.data, index);
    onClose();
  };

  return (
    <>
      <div className="w-full flex flex-col items-center gap-y-6">
        <FormFields.InputFormField
          form={form}
          formName={`tools.${index}.name`}
          label="Nome"
        />

        <FormFields.InputFormField
          form={form}
          formName={`tools.${index}.apiUrl`}
          label="URL"
        />

        <FormFields.TextareaFormField
          form={form}
          formName={`tools.${index}.description`}
          label="Descrição"
          rows={6}
        />

        <FormFields.SelectFormField
          form={form}
          formName={`tools.${index}.methodType`}
          label="Método"
          options={[
            { label: "GET", value: "GET" },
            { label: "POST", value: "POST" },
            { label: "PUT", value: "PUT" },
            { label: "DELETE", value: "DELETE" },
            { label: "PATCH", value: "PATCH" },
          ]}
        />

        <FormFields.SelectFormField
          form={form}
          formName={`tools.${index}.type`}
          label="Tipo"
          options={[
            { label: "CLIENTE", value: "CUSTOMER" },
            { label: "EMPRESA", value: "COMPANY" },
            { label: "LISTA DE ESPERA", value: "WAITLIST" },
            { label: "AGENDAMENTO", value: "SCHEDULING" },
          ]}
        />

        <Buttons.DefaultButton
          type="button"
          title="Salvar"
          onClick={onSubmit}
        />
      </div>
    </>
  );
};

export default UpdateToolForm;
